// extracted by mini-css-extract-plugin
export default {"formWrap":"checkform_formWrap__uvn2+","form":"checkform_form__BTGcQ","inline":"checkform_inline__zQRIo"};